<div class="page-title">Detalhes da composição</div>
<div class="details composition-details" *ngIf="composition">
  <div class="details__left">
    <div class="card card-user">
      <div class="image" [ngClass]="cardImageClass"></div>
      <div class="card-body">
        <div class="user">
          <img class="avatar" [src]="editionImage" *ngIf="editionImage" />
          <img
            class="avatar"
            src="assets/images/no_img_available.jpg"
            *ngIf="!editionImage"
          />
          <h4 *ngIf="!edit">
            {{ composition.compositionName }}
            <ng-container *ngIf="!composition.dateSyncERP">
              <br />
              <p-button
                styleClass="p-button-xs"
                *ngxPermissionsOnly="allowedPermissions"
                severity="danger"
                size="small"
                label="Editar nome"
                icon="pi pi-pencil"
                iconPos="left"
                (onClick)="editCompositionName()"
              ></p-button>
            </ng-container>
          </h4>
          <p *ngIf="edit">
            <input
              id="compositionName"
              type="text"
              pInputText
              [(ngModel)]="composition.compositionName"
              (blur)="changeCompositionName()"
            />
          </p>
          <p>Edição: {{ editionName }}</p>
          <p>Preço custo: {{ composition.costTotal | currency: 'BRL' }}</p>
          <p>Preço mercado: {{ composition.saleTotal | currency: 'BRL' }}</p>
          <p>Preço nota: {{ composition.invoiceTotal | currency: 'BRL' }}</p>
          <p>
            Data criação:
            {{ composition.dateCreated | date: 'dd/MM/yyyy HH:mm:ss' }}
          </p>
          <p *ngIf="composition.dateSyncERP">
            Data exportação:
            {{ composition.dateSyncERP | date: 'dd/MM/yyyy HH:mm:ss' }}
          </p>

          <p *ngIf="!composition.dateSyncERP && stockDifference">
            <strong>
              * O item {{ stockOutProduct?.productVariantName }} está sem
              estoque suficiente para
              {{ stockDifference | number: '1.0-0' }} assinantes
              <ng-container *ngxPermissionsExcept="allowedPermissions">
                , <u>entre em contato com o time de "Alocação"!</u>
              </ng-container>
            </strong>
          </p>
          <div class="actions" *ngxPermissionsOnly="allowedPermissions">
            <p-button
              *ngIf="composition.dateSyncERP"
              label="Verificar no Millennium"
              icon="pi pi-search"
              severity="secondary"
              size="small"
              [disabled]="millenniumLookupBusy"
              (onClick)="verifyInMillennium()"
            />
            <p-button
              severity="info"
              size="small"
              label="Repreparar composição"
              icon="pi pi-refresh"
              *ngxPermissionsOnly="['ROLE_ADMIN']"
              (onClick)="prepareComposition()"
            />
            <p-button
              label="Excluir"
              icon="pi pi-trash"
              *ngIf="!composition.dateSyncERP"
              (onClick)="askDeleteComposition()"
              severity="danger"
              size="small"
            />
            <p-button
              label="Validar assinantes"
              icon="pi pi-verified"
              *ngIf="!composition.dateSyncERP"
              severity="primary"
              size="small"
              (onClick)="validateSubscribers()"
            />
            <p-button
              label="Remover {{ stockDifference | number: '1.0-0' }} assinantes"
              icon="pi pi-user-minus"
              *ngIf="!composition.dateSyncERP && stockDifference"
              severity="help"
              size="small"
              [pTooltip]="
                'O item ' +
                stockOutProduct?.productVariantName +
                ' está sem estoque suficiente.'
              "
              tooltipPosition="bottom"
              (onClick)="removeSubscribers()"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="details__right">
    <div class="card">
      <p-tabView
        [activeIndex]="selectedTab"
        (activeIndexChange)="tabChanged($event)"
        *ngIf="ready"
      >
        <p-tabPanel header="Variantes ({{ compositionProducts?.length || 0 }})">
          <app-table
            *ngIf="variantCols() && compositionProducts"
            [cols]="variantCols()"
            [elements]="compositionProducts"
            modelName="variantes"
            sortField="productVariantName"
            [paginator]="false"
            [sortOrder]="-1"
            [lazy]="false"
            [exportPdf]="false"
            [exportExcel]="false"
            [addButton]="false"
            [showTitle]="false"
            [changeColumns]="true"
            [rowBackground]="rowBackground"
            (rowItemChanged)="changeCompositionProduct($event)"
            (booleanAction)="changeCompositionProduct($event)"
            [dropdownFilters]="dropdownFilters()"
            [multiSelectFilter]="true"
            (changedFilter)="filterChanged($event)"
          />
        </p-tabPanel>
        <p-tabPanel
          header="Assinantes ({{
            compositionSubscribers?.length | number: '1.0-0'
          }})"
        >
          <div *ngIf="subscriberEditionTotals?.length">
            <h4>Resumo das edições</h4>
            <p-table [value]="subscriberEditionMilleniumTotals">
              <ng-template pTemplate="header">
                <tr>
                  <th>Status edição</th>
                  <th
                    *ngFor="let total of subscriberEditionTotals; let i = index"
                    [ngStyle]="{
                      'background-color': subscriberStatusColor(total.id),
                      color: 'white',
                      'text-align': 'center'
                    }"
                    [attr.colspan]="total.statusList?.length"
                  >
                    {{ total.status | titlecase }}
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body">
                <tr>
                  <td class="fixed-data">Status Millennium</td>
                  <ng-container
                    *ngFor="
                      let total of subscriberEditionMilleniumTotals;
                      let i = index
                    "
                  >
                    <td
                      class="millennium-status"
                      *ngFor="let mill of total.statusList"
                    >
                      {{ mill.status | titlecase }} ({{
                        mill.subscribers | number: '1.0-0'
                      }})
                    </td>
                  </ng-container>
                </tr>
              </ng-template>
            </p-table>
          </div>
          <hr />
          <app-table
            *ngIf="subscriberCols && compositionSubscribers"
            [cols]="subscriberCols"
            [elements]="compositionSubscribers"
            modelName="assinantes"
            sortField="personName"
            [sortOrder]="-1"
            [lazy]="false"
            [exportPdf]="false"
            [exportExcel]="false"
            [addButton]="false"
            [showTitle]="false"
            [changeColumns]="true"
            [showFooter]="true"
            [dropdownFilters]="dropdownFilters()"
            [multiSelectFilter]="true"
          >
          </app-table>
        </p-tabPanel>
        <p-tabPanel
          header="Produção ({{
            compositionProductionSummary?.quantity || 0 | number: '1.0-0'
          }})"
        >
          <app-composition-production
            *ngIf="compositionProductionSummary && user?.username"
            [composition]="compositionProductionSummary"
            [username]="user.username"
            (productionChanged)="compositionProductionSummary = $event"
          ></app-composition-production>
        </p-tabPanel>
        <p-tabPanel
          header="Substituições ({{
            substitutions?.length || 0 | number : '1.0-0'
          }})"
          *ngIf="substitutions?.length"
        >
          <app-table
            [addButton]="false"
            modelName="substituições"
            [cols]="substitutionCols"
            [lazy]="false"
            [elements]="substitutions"
            sortField="personName"
          ></app-table>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
</div>
<p-confirmDialog styleClass="danger" />
<p-confirmDialog key="millenniumReexport" />
<app-millennium-allocation-dialog
  [visible]="millenniumAllocationVisible"
  [allocation]="millenniumAllocation"
  [detailMessage]="millenniumFoundDetail"
  (visibleChange)="millenniumAllocationVisible = $event"
/>
<p-toast />
<p-dialog
  [(visible)]="outOfStock"
  (onHide)="outOfStock = false"
  header="Atenção"
  [modal]="true"
  [closable]="true"
  [resizable]="false"
  [draggable]="false"
>
  <p>
    Infelizmente {{ stockDifference | number: '1.0-0' }} assinantes não poderão
    receber está composição, pois o item <br /><strong>{{
      stockOutProduct?.productVariantName
    }}</strong>
    está sem estoque suficiente.
    <br />
  </p>
  <p *ngxPermissionsOnly="allowedPermissions">O que deseja fazer?</p>
  <b *ngxPermissionsExcept="allowedPermissions">
    Entre em contato com o time de "Alocação"!
  </b>
  <div class="dialog-buttons" *ngxPermissionsOnly="allowedPermissions">
    <p-button
      styleClass="p-button-warning"
      label="Remover {{ stockDifference | number: '1.0-0' }} assinantes"
      (onClick)="removeSubscribers()"
    />
    <p-button
      styleClass="p-button-danger"
      label="Excluir composição"
      (onClick)="deleteComposition()"
    />
  </div>
</p-dialog>
